<template>
	<div class="px-3">
		<v-layout d-flex justify-center column>
			<v-btn
				flat
				class="primary white--text btn-detail btn-top mb-0"
			>
				{{ title }}
			</v-btn>
			<div class="border-right">
				<div class="row-line" v-for="(item, index) in rows" :key="`row-${item.id}`">
					<span class="number-row">{{ (index - 5) * -1 }}</span>
				</div>
				<template v-for="(item, indexItem) in rows">
					<v-tooltip top :key="item.id">
						<div
							slot="activator"
							class="container-weighing"
							:style="`right: ${(indexItem * 20) + 5}%; bottom: calc((${item.totalQuestions * 48}px) + ${item.totalQuestions === 0 ? 49 : 46}%);`"
						>
							<p
								v-if="item.totalQuestions"
								class="circle"
								:style="`background-color:${$appColors.success}`"
							>{{ item.totalQuestions }}</p>
							<img
								class="icon-accessibility"
								:src="item.urlImage"
								alt=""
								height="31"
								width="32"
							>
						</div>
						<span>{{ item.name }}</span>
					</v-tooltip>
				</template>
				<div class="border-bottom" :style="`border-bottom:1px solid ${$appColors.primary}`">
					<span class="origin primary--text caption">0</span>
				</div>
				<div class="row-line" v-for="(item, indexRow) in rowsInvested" :key="`invested-${item.id}`">
					<span class="number-row">{{ indexRow + 1 }}</span>
				</div>
				<template v-for="(item, indexInvested) in rowsInvested">
					<v-tooltip top :key="item.id">
						<div
							slot="activator"
							class="container-weighing"
							:style="`right: ${(indexInvested * 20) + 5}%; bottom: calc((${item.totalQuestions * -48}px) + ${item.totalQuestions === 0 ? 40 : 46}%);`"
						>
							<p
								v-if="item.totalQuestions"
								class="circle"
								:style="`background-color:${$appColors.success}`"
							>{{ item.totalQuestions }}</p>
							<img
								class="icon-accessibility"
								:src="item.urlImage"
								alt=""
								height="31"
								width="32"
							>
						</div>
						<span>{{ item.name }}</span>
					</v-tooltip>
				</template>
				<div class="row-line"></div>
			</div>
			<v-btn
				flat
				class="primary white--text btn-detail btn-bottom mt-0"
			>
				{{ titleInvested }}
			</v-btn>
		</v-layout>
	</div>
</template>

<script>
export default {
	name: 'component-weighing',
	props: {
		rows: {
			default: () => [],
			type: Array,
		},
		rowsInvested: {
			default: () => [],
			type: Array,
		},
		title: String,
		titleInvested: String,
	},
};
</script>

<style lang="scss" scoped>
	.circle {
		border-radius: 50%;
		color: map-get($colors, white);
		font-family: map-get($fonts, bold);
		height: 19px;
		line-height: 19px;
		position: absolute;
		text-align: center;
		right: -12px;
		top: -16px;
		width: 19px;
	}

	.icon-accessibility {
		filter: brightness(0) invert(0.4);
	}

	.border-bottom {
		margin-top: 48px;
		position: relative;
	}

	.number-row {
		color: map-get($colors, gray-medium);
		font-size: map-get($sizes, xsmall);
		position: absolute;
		right: -14px;
		top: 40px;
	}

	.origin {
		position: absolute;
		right: -14px;
		top: -9px;
	}

	.btn-detail {
		border-bottom: 0px;
		font-family: map-get($fonts, bold);
		margin-bottom: 10px;

		&.btn-top {
			border-top-left-radius: 9px;
			border-top-right-radius: 9px;
		}

		&.btn-bottom {
			border-bottom-left-radius: 9px;
			border-bottom-right-radius: 9px;
		}
	}

	.container-weighing {
		height: auto;
		position: absolute;
		transition: all .5s ease-in-out;
		z-index: 1;
	}

	.row-line {
		border-bottom: 1px solid map-get($colors, grey);
		height: 48px;
		position: relative;

		&:first-child,
		&:last-child {
			height: 31px;

			.container-weighing {
				top: 14px;
			}
		}

		&:first-child {
			.number-row {
				top: 22px;
			}

			.container-weighing {
				right: 10%;

				.circle {
					top: -10px;
				}
			}
		}

		&:nth-child(2) {
			.container-weighing {
				right: 35%;
			}
		}

		&:nth-child(3) {
			.container-weighing {
				right: 60%;
			}
		}

		&:nth-child(4) {
			.container-weighing {
				right: 85%;
			}
		}

		&:nth-child(5) {
			.container-weighing {
				right: 65%;
			}
		}

		&:nth-child(7) {
			.container-weighing {
				right: 84%;
			}
		}

		&:nth-child(8) {
			.container-weighing {
				right: 63%;
			}
		}

		&:nth-child(9) {
			.container-weighing {
				right: 55%;
			}
		}

		&:nth-child(10) {
			.container-weighing {
				right: 83%;
			}
		}
	}

	.border-right {
		border-right: 1px solid map-get($colors, gray-slider);
		margin: 0px 8px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/surveys/component-weighing.vue